import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

enum PartnerCompaniesContractStatusEnum {
  ACTIVE = 'Active',
  CANCELED = 'Canceled',
}

type PartnerCompaniesStatus = Record<
  PartnerCompaniesContractStatusEnum,
  string
>;

const PARTNER_COMPANIES_CONTRACT_STATUS_NAME: PartnerCompaniesStatus = {
  [PartnerCompaniesContractStatusEnum.ACTIVE]: 'Ativo',
  [PartnerCompaniesContractStatusEnum.CANCELED]: 'Cancelado',
};

const PARTNER_COMPANIES_CONTRACT_STATUS_COLOR: PartnerCompaniesStatus = {
  [PartnerCompaniesContractStatusEnum.ACTIVE]:
    NEW_COLORS.SEMANTICS.SUCCESS[700],
  [PartnerCompaniesContractStatusEnum.CANCELED]:
    NEW_COLORS.SEMANTICS.ERROR[600],
};

const PARTNER_COMPANIES_CONTRACT_STATUS_TEXT_COLOR: PartnerCompaniesStatus = {
  [PartnerCompaniesContractStatusEnum.ACTIVE]:
    NEW_COLORS.SEMANTICS.SUCCESS[700],
  [PartnerCompaniesContractStatusEnum.CANCELED]:
    NEW_COLORS.SEMANTICS.ERROR[600],
};

export {
  PARTNER_COMPANIES_CONTRACT_STATUS_NAME,
  PARTNER_COMPANIES_CONTRACT_STATUS_COLOR,
  PARTNER_COMPANIES_CONTRACT_STATUS_TEXT_COLOR,
  PartnerCompaniesContractStatusEnum,
};
